/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from 'react-metrics';
import { connect } from 'react-redux';

import { Helpers } from '../../../core/src/helpers';
import { fetchHeaderFooterComponent } from './header-footer-actions';
import { withError } from '../../../shared/components/error-boundary';
import Link from '../../../shared/components/hyperlink';
import withWindowResize from '../../../ui/components/window-resize';
import FooterDesktop from './footer-desktop';
import FooterMobile from './footer-mobile';
import ThirdPartyFix from './ThirdPartyFix';

import './css/footer.less';

export class Footer extends PureComponent {
    static propTypes = {
        /** footer data object, handled by redux store */
        footer: PropTypes.object.isRequired,
        /** fetch footer action if data is not set, handled by redux store actions */
        fetchFooter: PropTypes.func.isRequired,
        /** device type string (desktop|mobile) */
        device: PropTypes.string.isRequired,
        /** viewport width, handled by withWindowResize HoC */
        width: PropTypes.number,
    };

    static defaultProps = {
        width: 0
    }

    state = {
        showCountries: false,
    };

    // TODO: async load assets, and privacy_cookie.js
    componentDidMount() {
        const { footer, fetchFooter } = this.props;

        // fetch footer async
        // TODO: need a better flag for if the data needs to be fetched
        if (
            !footer.disabled &&
            (!footer.groups || Object.keys(footer.groups).length === 0)
        ) {
            fetchFooter();
        }
    }

    onShowCountries = (event) => {
        event.preventDefault();
        this.setState({ showCountries: true });
    };

    onCloseCountries = (event) => {
        event.preventDefault();
        this.setState({ showCountries: false });
    };

    onToggleCountries = (event) => {
        event.preventDefault();
        const { showCountries } = this.state;
        this.setState({ showCountries: !showCountries });
    };

    render() {
        const { showCountries } = this.state;
        const { footer, width, device } = this.props;
        const { barLinks, disabled, customHTML } = footer;

        // TEMP
        if (disabled || !barLinks) {
            return null;
        }
        if(customHTML){
            return <div dangerouslySetInnerHTML={ Helpers.createMarkup(customHTML) } />
        }

        return (
            <div className="footer-container">
                {/* TODO: clean up id once we consolidate to one footer */}
                <div className="footer" id="footer" name="footer">
                    {width > 768 || device === 'desktop' ? (
                        <FooterDesktop
                            footer={footer}
                            showCountries={showCountries}
                            onCloseCountries={this.onCloseCountries}
                            onToggleCountries={this.onToggleCountries}
                        />
                    ) : (
                        <FooterMobile
                            footer={footer}
                            showCountries={showCountries}
                            onToggleCountries={this.onToggleCountries}
                            onCloseCountries={this.onCloseCountries}
                        />
                    )}
                    <MetricsElement element="ul" className="privacy">
                        {barLinks.map((link, linkKey) => (
                            <li className="bar-link" key={linkKey}>
                                <Link
                                    data-metrics-event-name="linkClick"
                                    data-metrics-event={link.analyticsLinkType}
                                    data-metrics-link-id={link.analyticsLinkID}
                                    to={link.link}
                                    key={linkKey}
                                >
                                    {link.name}
                                </Link>
                                {barLinks.length !== linkKey + 1 && <span>{' | '}</span>}
                            </li>
                        ))}
                    </MetricsElement>
                    <div className="copyright">© Copyright 2020 HP Development Company, L.P.</div>
                </div>
                <ThirdPartyFix />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { footer } = state.headerFooter;
    return { footer };
};

const mapDispatchToProps = (dispatch) => ({
    fetchFooter: () => dispatch(fetchHeaderFooterComponent(['footer'])),
});

export default withError(withWindowResize(connect(mapStateToProps, mapDispatchToProps)(Footer)));
